<template>
	<div
		class="aup-base-tooltip"
		:class="{ 'p-1': !isWrapper, 'aup-base-tooltip--disabled': !content }"
		v-tooltip="options"
	>
		<slot v-if="isWrapper" />
		<div class="aup-base-tooltip__trigger" v-if="!isWrapper">
			<span class="aup-base-tooltip__trigger-symbol">error:call:47</span>
		</div>
	</div>
</template>
<script>
export default {
	name: 'BaseTooltip',
	props: {
		content: {
			type: String,
			default: null,
		},
		placement: {
			type: String,
			default: null,
		},
		tooltipCharacter: {
			type: String,
			default: 'i',
		},
		trigger: {
			type: String,
			default: 'click',
		},
		isWrapper: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			options: {
				content: this.content,
				placement: this.placement || 'top',
				html: true,
				trigger: this.trigger || 'click',
			},
		};
	},
	watch: {
		content: {
			handler(val) {
				this.options.content = val;
			},
		},
	},
};
</script>
<style lang="scss">
@import '../../assets/scss/all';
.aup-base-tooltip {
	position: relative;

	&__trigger {
		border-radius: 50%;
		border: solid 1px $gray-400;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 16px;
		width: 16px;
		transition: border-color 0.2s ease-in-out;
	}

	&__trigger-symbol {
		font-size: 0.6666rem;
		font-family: 'SSTProBold';
		color: $gray-400;
		display: block;
		line-height: 1;
		transition: color 0.2s ease-in-out;
	}

	&:hover,
	&.v-tooltip-open {
		cursor: pointer;
		.aup-base-tooltip__trigger-symbol {
			color: $primary;
		}

		.aup-base-tooltip__trigger {
			border-color: $primary;
		}
	}

	&--disabled {
		pointer-events: none;

		* {
			pointer-events: all
		}

		&:hover {
			cursor: default;
		}
	}
}

.tooltip {
	display: block !important;
	z-index: 10000;
}

.tooltip .tooltip-inner {
	background: $black;
	color: white;
	border-radius: 0.25rem;
	padding: 1rem 1rem 1rem 1rem;
	text-align: left;
	max-width: 300px;
	font-size: 12px;
	font-family: $font-family-regular;

	a {
		font-size: 1em;
		color: white;
		text-decoration: underline;
		transition: color 0.2s ease-in-out;

		&:hover {
			color: $primary;
		}
	}
}

.tooltip .tooltip-arrow {
	width: 0;
	height: 0;
	border-style: solid;
	position: absolute;
	margin: 5px;
	border-color: black;
}

.tooltip[x-placement^='top'] {
	margin-bottom: 5px;
}

.tooltip[x-placement^='top'] .tooltip-arrow {
	border-width: 5px 5px 0 5px;
	border-left-color: transparent !important;
	border-right-color: transparent !important;
	border-bottom-color: transparent !important;
	bottom: -5px;
	left: calc(50% - 5px);
	margin-top: 0;
	margin-bottom: 0;
}

.tooltip[x-placement^='bottom'] {
	margin-top: 5px;
}

.tooltip[x-placement^='bottom'] .tooltip-arrow {
	border-width: 0 5px 5px 5px;
	border-left-color: transparent !important;
	border-right-color: transparent !important;
	border-top-color: transparent !important;
	top: -5px;
	left: calc(50% - 5px);
	margin-top: 0;
	margin-bottom: 0;
}

.tooltip[x-placement^='right'] {
	margin-left: 5px;
}

.tooltip[x-placement^='right'] .tooltip-arrow {
	border-width: 5px 5px 5px 0;
	border-left-color: transparent !important;
	border-top-color: transparent !important;
	border-bottom-color: transparent !important;
	left: -5px;
	top: calc(50% - 5px);
	margin-left: 0;
	margin-right: 0;
}

.tooltip[x-placement^='left'] {
	margin-right: 5px;
}

.tooltip[x-placement^='left'] .tooltip-arrow {
	border-width: 5px 0 5px 5px;
	border-top-color: transparent !important;
	border-right-color: transparent !important;
	border-bottom-color: transparent !important;
	right: -5px;
	top: calc(50% - 5px);
	margin-left: 0;
	margin-right: 0;
}

.tooltip[aria-hidden='true'] {
	visibility: hidden;
	opacity: 0;
	transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden='false'] {
	visibility: visible;
	opacity: 1;
	transition: opacity 0.15s;
}
</style>
